import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import '../index.scss';

export default class BookerAccountInfo extends React.Component {
  constructor(props) {
    super(props);

    // const { business } = this.props;
    this.state = {
      organizationId: '',
      mandatoryFieldError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount(){
    const { softwares } = this.props;
    const { zenotiData, form , LOGIN , PASSWORD} = softwares;
    console.log('LOGIN 1',form , LOGIN , PASSWORD, this.state);
    console.log('props', this.props);
    this.setState({
      ...((zenotiData.organizationId || form.organizationId) && {organizationId: form.organizationId?form.organizationId:zenotiData.organizationId})
    });
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onNextButtonClick() {
    const { organizationId } = this.state;

    const data = {
      client:'DENTRIX_ASCEND',
      organizationId,
    };
    const validationResult = this.validate(data);

    if (validationResult) {
      this.props.postZenotiAccountInfo(data);
      this.props.storeZentiData(data)
    }
  }

  validate(data) {
    if (!data.organizationId) {
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }

    this.setState({
      mandatoryFieldError: false,
    });

    return true;
  }

  render() {
    const { organizationId, mandatoryFieldError } = this.state;
    const { softwares } = this.props;
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Fields marked in red are mandatory!
            </p>
          ) : null}
          {softwares.isBookerAccountInfoSaveFail ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Unable to save organizationId information
            </p>
          ) : null}
        
          <div className="authorize-access__form__row form-group">
            <p className="form-group__heading">Enter your organization ID *</p>
            <input
              type="text"
              name="organizationId"
              className={classnames({ 'has-error': mandatoryFieldError })}
              value={organizationId}
              onChange={this.onInputChange}
              autoComplete="false"
            />
          </div>

        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={this.props.onBackClick}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={softwares.isSavingBookerAccountInfo}
          >
            {!softwares.isSavingBookerAccountInfo ? 'Next' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

BookerAccountInfo.defaultProps = {
  postZenotiAccountInfo: () => {},
  onBackClick: () => {},
};

BookerAccountInfo.propTypes = {
  postZenotiAccountInfo: PropTypes.func,
  onBackClick: PropTypes.func,
  softwares: PropTypes.shape().isRequired,
};